'use strict'

const PropTypes = require('prop-types')
const types = require('../../types')
const React = require('react')

const GeneralSupportForm = require('../../components/contact/general-support-form.js')
const Select = require('../inputs/select')

class AccountForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.shouldShowSubForm = this.shouldShowSubForm.bind(this)

    this.state = {
      showSubForm: this.shouldShowSubForm(props),
    }
  }

  shouldShowSubForm(props) {
    const {formData} = props
    if (!formData) return false
    if (!formData.contact) return false
    if (!formData.contact['account-inquire']) return false
    if (formData.contact['account-inquire'].value === 'none-selected') return false

    return true
  }

  onChange(e) {
    this.setState({
      showSubForm: e.value !== 'none-selected',
    })
  }

  render() {
    const {formData, disableUsernameField, onSubmit, showCaptcha} = this.props

    const values = [
      {
        value: 'none-selected',
        label: 'Choose one of the following',
      },
      {
        value: 'other-account-issue',
        label: 'General account & billing issue',
      },
      {
        value: 'dsr-export',
        label: 'Data export request',
      },
      {
        value: 'account',
        label: "I'm having trouble with my password, 2FA, or using my account",
      },
    ]

    return (
      <div>
        <Select
          label="My Account Issue"
          formId="contact"
          name="account-inquire"
          formData={formData}
          className="category"
          onChange={this.onChange}
          values={values}
        />
        {this.state.showSubForm && (
          <div>
            <GeneralSupportForm
              onSubmit={onSubmit}
              formData={formData}
              disableUsernameField={disableUsernameField}
              showCaptcha={showCaptcha}
            />
          </div>
        )}
      </div>
    )
  }
}

AccountForm.propTypes = {
  formData: types.formData.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableUsernameField: PropTypes.bool,
  showCaptcha: PropTypes.bool,
}

module.exports = AccountForm
